import styled from "styled-components";

export const ListingWrapper = styled.div`
  .headerWrapper {
    display: flex;
    flex-direction: column;
    gap: 50px;
    margin-bottom: 20px;
  }
  .headerInfo {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    .infoWrapper {
      display: flex;
      align-items: center;
      gap: 5px;
      font-weight: 500;
      .infoValue {
        font-size: 1.2em;
        color: #376fd0;
      }
    }
  }
`;
